import { guidEmpty } from '../../../../common/constants';
import { DigitalCorrespondanceTable, Dictionary, DigitalSet, Identifier } from '@models/index';
import { CorrespondanceTableViewModel } from './CorrespondanceTableViewModel';

export function rebuildViewModels(
    correspondanceTables: Dictionary<DigitalCorrespondanceTable>,
    digitalSets: Dictionary<DigitalSet>,
    identifiers: Dictionary<Identifier>) {
    const ctvm: CorrespondanceTableViewModel[] = [];
    if (correspondanceTables && digitalSets && identifiers) {
        const usedGuids = Object.values(identifiers)
            .filter(d => d.correspondanceTableGuid && d.correspondanceTableGuid !== guidEmpty)
            .map(d => d.correspondanceTableGuid);
        Object.keys(correspondanceTables)
            .forEach(k => {
                const ct = correspondanceTables[k];
                ctvm.push(
                    {
                        canDelete: usedGuids.indexOf(k) < 0,
                        table: ct,
                        layers: ct.layers.map(l => digitalSets[l.digitalSetGuid])
                    });
            });
    }
    return ctvm;
}